export class SurveyProgress {
  constructor(
    public answerJson: string,
    public submittedQuestionIds: string[],
    public terminatedQuestionId: string | null = null
  ) {}
}
